import React from 'react'
import InfoIcon from '@mui/icons-material/Info'
import GroupsIcon from '@mui/icons-material/Groups'
import TaskAltIcon from '@mui/icons-material/TaskAlt'
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch'
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail'
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges'

const RenderTypeComponent = ({ type, origin = '' }) => {
  return (
    <>
      {type === 'team' ? (
        <GroupsIcon sx={{ height: 30, width: 30, color: 'rgb(114, 229, 218)' }} />
      ) : type === 'task' ? (
        <TaskAltIcon sx={{ height: 30, width: 30, color: 'rgb(159, 90, 253)' }} />
      ) : type === 'mention' ? (
        <AlternateEmailIcon sx={{ height: 30, width: 30, color: 'rgb(114, 229, 218)' }} />
      ) : type === 'status' ? (
        <PublishedWithChangesIcon sx={{ height: 30, width: 30, color: 'rgb(114, 229, 218)' }} />
      ) : type === 'assignment' && origin === 'projects' ? (
        <RocketLaunchIcon sx={{ color: 'rgb(245, 108, 53)' }} />
      ) : type === 'assignment' && origin === 'teamtasks' ? (
        <TaskAltIcon sx={{ color: 'rgb(247, 63, 236)' }} />
      ) : (
        <InfoIcon sx={{ height: 30, width: 30, color: 'rgb(114, 229, 218)' }} />
      )}
    </>
  )
}

export default RenderTypeComponent
